import { css, type ThemeOptions } from '@mui/material/styles';

import type {} from '@mui/x-tree-view/themeAugmentation';

export const treeItemThemes: ThemeOptions['components'] = {
  MuiTreeItem: {
    styleOverrides: {
      root: {},
      content: ({ theme }) => css`
        gap: 4px;

        &:hover {
          background-color: ${theme.color['surface/hover']};
        }

        &[data-focused],
        &[data-selected],
        &[data-selected][data-focused] {
          background-color: ${theme.color['surface/select']};

          &:active,
          &:hover {
            background-color: ${theme.color['surface/press']};
          }
        }

        &[data-disabled] {
          color: ${theme.color['text/disabled']};
          opacity: 1;
        }
      `,
      groupTransition: {},
      iconContainer: {},
      label: {},
      checkbox: {},
      expanded: {},
      selected: {},
      focused: {},
      disabled: {},
    },
  },
};
